import { render, staticRenderFns } from "./NavBox.vue?vue&type=template&id=43ff2c7b&scoped=true"
import script from "./NavBox.vue?vue&type=script&lang=js"
export * from "./NavBox.vue?vue&type=script&lang=js"
import style0 from "./NavBox.vue?vue&type=style&index=0&id=43ff2c7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ff2c7b",
  null
  
)

export default component.exports